<template>
    <div>
        <apexchart v-if="data.categories !== undefined && data.series !== undefined"
            height="250px"
            :width="width ? width : '100%'"
            :type="type ? type: 'line'"
            :options="{
                chart: {
                    animations: {
                        enabled: false
                    }
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        show: !historic ? true : false,
                        datetimeUTC: false,
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '45%', //bar thickness
                    },
                },
                tooltip: {
                    x: {
                        show: true,
                        format: !historic ? 'HH:mm' : 'dd',
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: !historic ? 'smooth' : undefined,
                }
            }"
            :series="!historic 
                ? data.series.map( s => { return { name: `Line ${parseInt(s.line) + 1} - ${s.prop === 'watts' ? 'kilowatts' : s.prop}`, data: s.data } })
                : data.series.map( s => ({ name: s.prop, data: s.data }) )
            "
        ></apexchart>
        <p v-else>Loading ...</p> <!--v-else-->
    </div>
</template>

<script>
export default {
    name: 'Home',
    props: ['data', 'type', 'width', 'historic']
};
</script>
<style scoped>
</style>
